import {useTranslation} from '@aboutyou/i18n';
import {
  COLORS,
  FONT_SIZES,
  FONT_WEIGHTS,
  SPACING,
} from '@aboutyou/ui-components';

import {styled} from '@linaria/react';
import React from 'react';
import {BnplSlotName} from './constants';

export const RecommendedBadgeSlot = () => {
  const {t} = useTranslation();

  return (
    <div
      slot={BnplSlotName.optionUnderLabel}
      data-testid="bnpl-recommended-badge"
    >
      <Badge>{t('Recommended')}</Badge>
    </div>
  );
};

const Badge = styled.span`
  position: relative;
  z-index: 0;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  padding: 4px ${SPACING['X.Md']};
  font-size: ${FONT_SIZES.px10};
  font-weight: ${FONT_WEIGHTS.mediumBold};
  line-height: 0.8;
  color: ${COLORS.Black};
  white-space: nowrap;
  letter-spacing: -0.2px;
  margin-left: ${SPACING['X.Xl2']};

  &::before {
    content: '';
    position: absolute;
    inset: -50%;
    z-index: -2;
    background: conic-gradient(
      transparent 0%,
      rgba(44, 196, 176, 0.1) 15%,
      #2cc4b0 30%,
      rgba(44, 196, 176, 0.1) 45%,
      transparent 60%
    );
    animation: sweep-border 2s linear infinite;
  }

  &::after {
    content: '';
    position: absolute;
    inset: 1.5px;
    z-index: -1;
    border-radius: calc(20px - 1.5px);
    background-color: #ececec;
  }

  @keyframes sweep-border {
    to {
      transform: rotate(360deg);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    &::before {
      animation: none;
    }
  }
`;
